import React, { useEffect, useRef, useState, useContext } from "react";
import "./css/chat.css";
import CustomSvg from "../svgs/CustomSvg";
import userProfile1 from "../../assets/images/userProfile1.png";
import userProfile2 from "../../assets/images/userProfile2.png";
import userProfile3 from "../../assets/images/userProfile3.png";
import userProfile4 from "../../assets/images/userProfile4.png";
import userProfile5 from "../../assets/images/userProfile5.png";
import userProfile6 from "../../assets/images/userProfile6.png";
import DisplayUsers from "../games/auxiliary/DisplayUsers";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import { CSSTransition } from "react-transition-group";
import PlayerProfile from "./auxiliary/PlayerProfile";
import { IoArrowBackSharp } from "react-icons/io5";
import FloatingBtn from "../customBtns/FloatingBtn";
import { Offcanvas } from "react-bootstrap";
import CollapseBlock from "../dashboard/CollapseBlockLeft/collapseblockleft";
import CollapseBlockRight from "../dashboard/collapseblockright/collapseblockright";
import { getRequest } from "../apiRequests/requestApi";
import { UserContext } from "../../utils/contexts/UserContext";

const categories = [
  {
    name: "all",
  },
  {
    name: "wins",
  },
  {
    name: "male",
  },
  {
    name: "female",
  },
  {
    name: "new",
  },
  {
    name: "old",
  },
  {
    name: "rookies",
  },
];

export default function AllUsers({accountType}) {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const allUsers = useRef([]);
  const playerProfileNodeRef = useRef(null);
  const userContext = useContext(UserContext);
  const currentUserId = userContext?.user?._id;

  const [showAllUsers, setShowAllUsers] = useState(true);
  const [activeCategory, setActiveCategory] = useState("all");
  const [filteredUsers, setFilteredUsers] = useState(users);
  const [searchFilter, setSearchFilter] = useState("");
  const [activePlayer, setActivePlayer] = useState();
  const [showOffcanvasMenu, setShowOffcanvasMenu] = useState(false);
  const [isLeftBlockOpen, setIsLeftBlockOpen] = useState(true);
  const [isRightBlockOpen, setIsRightBlockOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState("both");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setIsLoading(true);
        const response = await getRequest("/gamers");
        const filteredUsers = response.data
          .filter((user) => user._id !== currentUserId)
          .map((user) => ({
            ...user,
            profile: user.avatar || userProfile1,
            bgClass: "bg-FD8D84",
            category: "all",
          }));
        setUsers(filteredUsers);
        allUsers.current = filteredUsers;
        setFilteredUsers(filteredUsers);
      } catch (err) {
        setError(err.message || "Failed to fetch users");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, [currentUserId]);

  useEffect(() => {
    if (isLeftBlockOpen && isRightBlockOpen) {
      setBlocksOpen("both");
    }

    if (!isLeftBlockOpen && !isRightBlockOpen) {
      setBlocksOpen("none");
    }

    if (
      (!isLeftBlockOpen && isRightBlockOpen) ||
      (isLeftBlockOpen && !isRightBlockOpen)
    ) {
      setBlocksOpen("one");
    }
  }, [isLeftBlockOpen, isRightBlockOpen]);

  useEffect(() => {
    if (activeCategory) {
      setSearchFilter("");

      if (activeCategory === "all") {
        setFilteredUsers(allUsers.current);
      } else {
        const _filteredUsers = allUsers.current.filter(
          (user) =>
            user.category?.toLowerCase() === activeCategory.toLowerCase()
        );
        setFilteredUsers(_filteredUsers);
      }
    }
  }, [activeCategory]);

  useEffect(() => {
    if (activeCategory) {
      const categoryFiltered =
        activeCategory == "all"
          ? allUsers.current
          : allUsers.current.filter(
              (user) =>
                user.category.toLowerCase() === activeCategory.toLowerCase()
            );

      if (searchFilter) {
        const _filteredUsers = categoryFiltered.filter((user) =>
          user?.username?.toLowerCase().includes(searchFilter.toLowerCase())
        );
        setFilteredUsers(_filteredUsers);
      } else {
        setFilteredUsers(categoryFiltered);
      }
    }
  }, [searchFilter]);

  useEffect(() => {
    if (showOffcanvasMenu) {
      setSearchFilter("");
      setActiveCategory("all");
      setFilteredUsers(users);
    }
  }, [showOffcanvasMenu]);

  const openOffcanvasMenu = () => setShowOffcanvasMenu(true);
  const closeOffcanvasMenu = () => setShowOffcanvasMenu(false);
  const toggleOffcanvasMenu = () => setShowOffcanvasMenu((prev) => !prev);

  const onSearchFilterChange = (e) => setSearchFilter(e.target.value);

  const selectPlayer = (player) => setActivePlayer(player);
  const hideActivePlayer = () => setActivePlayer();

  const displayCategories = categories.map((category, i) => {
    const { name } = category;

    const isActive = name == activeCategory ? true : false;

    const selectCategory = () => {
      setActiveCategory(name);

      return closeOffcanvasMenu();
    };

    return (
      <div
        key={i}
        onClick={selectCategory}
        className={`${
          isActive ? "bg-BE3593" : "bg-transparent"
        } mb-lg-0 mb-md-0 mb-3 col-lg-auto col-md-auto col-5 clickable chat-users-section-filter-container col-lg-1 d-flex align-items-center justify-content-center px-5 py-2`}
      >
        <p
          className={`${
            isActive ? "txt-FFF" : "txt-BD3193"
          } m-0 p-0 font-weight-600 font-family-poppins line-height-24 small-txt text-capitalize`}
        >
          {name}
        </p>
      </div>
    );
  });

  if (isLoading) {
    return (
      <div
        className="dashboard text-white d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="dashboard text-white d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen flex flex-col bg-[#130828]">
      <DashboardHeader />
      <div className="mt-4 md:flex md:mt-4 md:px-4 lg:flex lg:mt-4 lg:px-4 items-start justify-between">
       
        <div
          className={`${
            isLeftBlockOpen ? "w-1/6" : "w-1/12"
          } hidden md:flex lg:flex`}
        >
          <CollapseBlock setIsLeftBlockOpen={setIsLeftBlockOpen} />
        </div>

        {/* Main Content */}
        <div
          className={` mx-auto px-3 md:px-4 lg:px-4 `}
        >
          <div>
            {showAllUsers && (
                <div>
                  <div className="mb-4 flex items-center justify-between p-2">
                  <div className="w-[3%]">
                    <CustomSvg name="search" />
                  </div>
                  <input
                    placeholder="Search users"
                    className="text-white mx-4 font-quantico regular-txt w-[94%] bg-transparent outline-none"
                    value={searchFilter}
                    onInput={onSearchFilterChange}
                  />
                </div>

                <div className="hidden md:flex lg:flex items-center justify-between mb-5">
                  {displayCategories}
                </div>

                <DisplayUsers
                  users={filteredUsers}
                  btnTxt={"View"}
                  btnFunc={selectPlayer}
                  accountType = {accountType}
                />
                </div>
            )}

            <CSSTransition
              in={!!activePlayer}
              timeout={300}
              classNames="alert"
              unmountOnExit
              nodeRef={playerProfileNodeRef}
              onEnter={() => setShowAllUsers(false)}
              onExited={() => setShowAllUsers(true)}
            >
              <div ref={playerProfileNodeRef}>
                {/* <button
                  onClick={hideActivePlayer}
                  className="w-1/4 bg-transparent create-lobby-join-btn flex items-center justify-center p-2 mb-5"
                >
                  <div className="m-0 p-0 mx-1 flex items-center">
                    <IoArrowBackSharp size={20} color="#fff" />
                  </div>
                  <p className="p-0 m-0 text-sm text-white font-poppins font-medium mx-1">
                    Back
                  </p>
                </button> */}
                <PlayerProfile player={activePlayer} accountType={accountType} />
              </div>
            </CSSTransition>
          </div>
        </div>

        {/* Right Sidebar (hidden on small screens) */}
        <div
          className={`${
            isRightBlockOpen ? "w-1/6" : "w-1/12"
          } hidden md:flex lg:flex items-center justify-end`}
        >
          <CollapseBlockRight setIsRightBlockOpen={setIsRightBlockOpen} />
        </div>
      </div>

      {/* Floating button for small screens */}
      {/* <div className="block w-full md:hidden lg:hidden">
        <FloatingBtn icon="leftMenu" btnFunc={toggleOffcanvasMenu} />
      </div> */}

      <Offcanvas show={showOffcanvasMenu}>
        <div className="navContainer w-full h-full bg-[#130828] overflow-y-auto max-h-screen">
          <div className="w-full h-full navContainer p-4">
            <div className="flex items-center justify-between mb-5">
              <h1 className="m-0 p-0 font-quantico font-extrabold text-2xl text-white">
                Filter <span className="create-lobby-title-span">Users</span>
              </h1>
              <div onClick={closeOffcanvasMenu} className="cursor-pointer">
                <CustomSvg name="x" color="#FFF" />
              </div>
            </div>

            <div>
              <div className="mb-4 flex items-center justify-between p-2">
                <div className="w-[3%]">
                  <CustomSvg name="search" />
                </div>
                <input
                  placeholder="Search users"
                  className="text-white mx-4 font-quantico regular-txt w-[94%] bg-transparent outline-none"
                  value={searchFilter}
                  onInput={onSearchFilterChange}
                />
              </div>

              <div className="flex flex-wrap items-center justify-between mb-5">
                {displayCategories}
              </div>

              <button
                onClick={closeOffcanvasMenu}
                className="w-full bg-pink-700 flex items-center justify-center p-2 mb-5"
              >
                <div className="m-0 p-0 flex items-center">
                  <CustomSvg name="search" />
                </div>
                <p className="p-0 m-0 text-sm text-white font-poppins font-medium mx-2">
                  Search
                </p>
              </button>
            </div>
          </div>
        </div>
      </Offcanvas>
    </div>
  );
}
